/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_TitleInputs */

const en_us2_exercise_personal_goal_title = /** @type {(inputs: Exercise_Personal_Goal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goal`)
};

const pt_br2_exercise_personal_goal_title = /** @type {(inputs: Exercise_Personal_Goal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta`)
};

const es_419_exercise_personal_goal_title = /** @type {(inputs: Exercise_Personal_Goal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta`)
};

const pt_pt2_exercise_personal_goal_title = /** @type {(inputs: Exercise_Personal_Goal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo`)
};

const fr_fr2_exercise_personal_goal_title = /** @type {(inputs: Exercise_Personal_Goal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif`)
};

const de_de2_exercise_personal_goal_title = /** @type {(inputs: Exercise_Personal_Goal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel`)
};

const it_it2_exercise_personal_goal_title = /** @type {(inputs: Exercise_Personal_Goal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo`)
};

/**
* | output |
* | --- |
* | "Goal" |
*
* @param {Exercise_Personal_Goal_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_title = /** @type {((inputs?: Exercise_Personal_Goal_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_title(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_title(inputs)
	return en_us2_exercise_personal_goal_title(inputs)
});
export { exercise_personal_goal_title as "exercise-personal.goal_title" }